<div class="company-container">
  <div class="top-part">
    <div class="top-part-wrap">
      <div class="goals-navbar d-flex me-5 mb-2">
        <button
          class="nav-link align-items-center"
          [class.active]="isPriceActive == true"
          (click)="activeTab(true)"
        >
          Active Pricing
        </button>
        <button
          class="nav-link"
          [class.active]="isPriceActive == false"
          (click)="activeTab(false)"
        >
          Inactive Pricing
        </button>
      </div>

      <div class="second-section d-flex align-items-center justify-content-end">
        <span matTooltip="Export data" matTooltipPosition="above">
          <button class="btn filter-btn" (click)="exportToExcel()">
            <img
              style="width: 22px"
              src="../../../assets/Pricingscreen/export.svg"
            />
          </button>
        </span>
        <span matTooltip="Filter Data" matTooltipPosition="above">
          <button
            class="btn filter-btn ms-2"
            data-bs-target="#filterData"
            data-bs-toggle="modal"
            (click)="openFilterModal('Open')"
          >
            <img
              style="width: 22px"
              src="../../../assets/Pricingscreen/filter.svg"
            />
          </button>
        </span>
        <ng-template [ngxPermissionsOnly]="['Pricing:Delete']">
          <span matTooltip="Delete Record(s)" matTooltipPosition="above">
            <button
              *ngIf="isPriceActive"
              class="btn filter-btn ms-2"
              data-toggle="modal"
              data-backdrop="static"
              data-target="#deleteDataModal"
            >
              <img
                style="width: 22px"
                src="../../../assets/Pricingscreen/delete.svg"
              />
            </button>
          </span>
        </ng-template>

        <ng-template [ngxPermissionsOnly]="['Pricing:Create']">
          <div
            class="create-btn ms-2"
            data-bs-target="#addPriceConfigModal"
            data-bs-toggle="modal"
            (click)="emptyform()"
          >
            <img src="../../../../../assets/icons/whitePlus.svg" />
            Add New
          </div>
        </ng-template>

        <ng-template [ngxPermissionsOnly]="['Pricing:Delete']">
          <div
            class="create-btn ms-2"
            data-bs-target="#resetPricing"
            data-bs-toggle="modal"
            (click)="emptyform()"
          >
            Reset Pricing
          </div>
        </ng-template>

        <div class="dropdown custom-left ms-2">
          <button
            class="btn dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            id="removeContent"
            matTooltip="More Options"
            matTooltipPosition="above"
            matTooltipClass="raised-tooltip"
          >
            <img src="../../../../assets/Pos-Catalog/importdots.svg" />
          </button>
          <div class="dropdown-menu" id="firstDropdown">
            <div class="first-part">
              <ul class="dropdown-list list-unstyled mb-0">
                <li>
                  <a class="dropdown-item" (click)="downloadTemplate()"
                    ><img
                      class="me-3"
                      src="../../../../assets/Pos-Catalog/arrowDown.svg"
                    />Download Template</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" (click)="triggerFileInput()"
                    ><img
                      class="me-3"
                      src="../../../../assets/Pos-Catalog/arrowDown.svg"
                    />Import Pricing</a
                  >
                  <input
                    #fileInput
                    type="file"
                    accept=".xlsx,.xls"
                    style="display: none"
                    (change)="onFileSelected($event)"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="intro">
    <div class="table-container">
      <table class="table category-table table-condensed" *ngIf="isPriceActive">
        <thead class="main-head sticky-top">
          <tr>
            <th scope="col" style="align-items: center; text-transform: none">
              <label for="flexCheckDefault">
                Store Group
                <img
                  style="margin: 0 0 2px 1px; cursor: pointer"
                  src="../../../assets/Pricingscreen/sorting_val.svg"
                  (click)="sortValues('storeGrp')"
                />
              </label>
              <i
                class="fa-regular fa-circle-xmark"
                (click)="clearFilter('Store')"
                *ngIf="storeGroupIDs.length > 0 && isFilterApplied"
              ></i>
            </th>
            <th scope="col" style="text-transform: none">
              Department
              <img
                style="margin: 0 0 2px 1px; cursor: pointer"
                src="../../../assets/Pricingscreen/sorting_val.svg"
                (click)="sortValues('deptDesc')"
              />
              <i
                class="fa-regular fa-circle-xmark"
                (click)="clearFilter('Department')"
                *ngIf="filterDepartmentIDs.length > 0 && isFilterApplied"
              ></i>
            </th>
            <th scope="col" style="text-transform: none">
              Category
              <img
                style="margin: 0 0 2px 1px; cursor: pointer"
                src="../../../assets/Pricingscreen/sorting_val.svg"
                (click)="sortValues('ctgName')"
              />
              <i
                class="fa-regular fa-circle-xmark"
                (click)="clearFilter('Category')"
                *ngIf="filterCategoriesIDs.length > 0 && isFilterApplied"
              ></i>
            </th>
            <th scope="col" style="text-transform: none">
              Sub-Category
              <img
                style="margin: 0 0 2px 1px; cursor: pointer"
                src="../../../assets/Pricingscreen/sorting_val.svg"
                (click)="sortValues('subCtgName')"
              />
            </th>
            <th scope="col" style="text-transform: none">
              Quality
              <i
                class="fa-regular fa-circle-xmark"
                (click)="clearFilter('Quality')"
                *ngIf="QualityConfigIDs.length > 0 && isFilterApplied"
              ></i>
            </th>
            <th scope="col" style="text-transform: none">
              Condition
              <i
                class="fa-regular fa-circle-xmark"
                (click)="clearFilter('Condition')"
                *ngIf="conditionIDs.length > 0 && isFilterApplied"
              ></i>
            </th>
            <th scope="col" style="text-transform: none">
              Price Type
              <i
                class="fa-regular fa-circle-xmark"
                (click)="clearFilter('Config')"
                *ngIf="filterConfigIDs.length > 0 && isFilterApplied"
              ></i>
            </th>
            <th
              scope="col"
              style="
                width: 5% !important;
                text-align: center; 
                text-transform: non;
              "
            >
              Price
            </th>

            <ng-template [ngxPermissionsOnly]="['Pricing:Update']">
              <th
                scope="col"
                style="text-align: center; width: 15%; text-transform: none"
              >
                Actions
              </th>
            </ng-template>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let config of Deptpriceconfigarray; let i = index"
            [ngClass]="{ 'highlighted-row': i === selectedRowIndex }"
          >
            <td>
              <div class="d-flex align-items-center">
                <input
                  style="height: 20px; width: 20px; margin-right: 10px"
                  class="form-check-input mt-0 me-2"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault1"
                  (click)="handleCheck(config)"
                  [checked]="config.isChecked"
                />
                <label for="" style="font-size: 14px; font-weight: 700">{{
                  config.name
                }}</label>
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center">
                <span>{{ config.department }}</span>
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center">
                <span>{{ config.categoryName }}</span>
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center">
                <span>{{ config.subCategoryName }}</span>
              </div>
            </td>
            <td>
              <div
                class="quality-conditions"
                [style.backgroundColor]="config.qualityColor"
              >
                <span>{{ config.qualityDescr }}</span>
              </div>
            </td>
            <td>
              <div
                class="quality-conditions"
                [style.borderColor]="config.conditionColor"
              >
                <span>{{ config.conditionDescr }}</span>
              </div>
            </td>
            <td>{{ config.description }}</td>
            <td style="text-align: end">
              <span [hidden]="openInput && i === selectedRowIndex">{{
                config.price | currency
              }}</span>
              <div
                class="price-input ps-2"
                [hidden]="!openInput || i !== selectedRowIndex"
              >
                $<input
                  type="text"
                  [(ngModel)]="config.price"
                  appTwoDigitDecimaNumber
                />
              </div>
            </td>
            <td style="text-align: center">
              <ng-template [ngxPermissionsOnly]="['Pricing:Update']">
                <div
                  class="btn-group dropleft"
                  style="gap: 10px"
                  [hidden]="editZone && i === selectedRowIndex"
                >
                  <span matTooltip="Edit Record" matTooltipPosition="above">
                    <button
                      type="button"
                      class="action-drop me-2"
                      data-bs-toggle="modal"
                      (click)="editPriceConfig(i)"
                    >
                      <i
                        ><img
                          style="width: 25px; height: 25px"
                          src="../../../assets/Pricingscreen/update.svg"
                      /></i>
                    </button>
                  </span>
                  <span matTooltip="Configure Price" matTooltipPosition="above">
                    <button
                      type="button"
                      class="action-drop"
                      data-bs-target="#setPriceConfigModal"
                      data-bs-toggle="modal"
                      (click)="getPricingConfigByID(config)"
                    >
                      <i
                        ><img
                          style="width: 25px; height: 25px"
                          src="../../../assets/Pricingscreen/setting.svg"
                      /></i>
                    </button>
                  </span>
                </div>
              </ng-template>

              <div
                class="btn-group dropleft"
                [hidden]="!editZone || i !== selectedRowIndex"
              >
                <span matTooltip="Update Price" matTooltipPosition="above">
                  <button
                    type="button"
                    class="action-drop me-2"
                    data-bs-toggle="modal"
                    (click)="cancelPrice(config, i)"
                  >
                    <i
                      ><img
                        width="20"
                        src="../../../assets/Pricingscreen/cancel.svg"
                    /></i>
                  </button>
                </span>
                <button
                  type="button"
                  class="action-drop"
                  data-bs-toggle="modal"
                  (click)="updatePrice(config)"
                >
                  <i
                    ><img
                      width="20"
                      src="../../../assets/Pricingscreen/save.svg"
                  /></i>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="Deptpriceconfigarray.length == 0 && !isLoading">
            <td colspan="8" style="text-align: center">
              <h5>Sorry there is no data</h5>
            </td>
          </tr>
        </tbody>
      </table>

      <table
        class="table category-table table-condensed mb-0"
        *ngIf="!isPriceActive"
      >
        <thead class="sticky-top">
          <tr>
            <th scope="col" style="align-items: center">
              <label for="flexCheckDefault">
                Store Group
                <img
                  style="margin: 0 0 2px 1px; cursor: pointer"
                  src="../../../assets/Pricingscreen/sorting_val.svg"
                  (click)="sortValues('storeGrp')"
                />
              </label>
              <i
                class="fa-regular fa-circle-xmark"
                (click)="clearFilter('Store')"
                *ngIf="storeGroupIDs.length > 0"
              ></i>
            </th>
            <th scope="col">
              Department
              <img
                style="margin: 0 0 2px 1px; cursor: pointer"
                src="../../../assets/Pricingscreen/sorting_val.svg"
                (click)="sortValues('deptDesc')"
              />
              <i
                class="fa-regular fa-circle-xmark"
                (click)="clearFilter('Department')"
                *ngIf="filterDepartmentIDs.length > 0"
              ></i>
            </th>
            <th scope="col">
              Category
              <img
                style="margin: 0 0 2px 1px; cursor: pointer"
                src="../../../assets/Pricingscreen/sorting_val.svg"
                (click)="sortValues('ctgName')"
              />
              <i
                class="fa-regular fa-circle-xmark"
                (click)="clearFilter('Category')"
                *ngIf="filterCategoriesIDs.length > 0"
              ></i>
            </th>

            <th scope="col" style="text-align: center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let config of Deptpriceconfigarray; let i = index"
            [ngClass]="{ 'highlighted-row': i === selectedRowIndex }"
          >
            <td>
              <div class="d-flex align-items-center">
                <label for="" style="font-size: 14px; font-weight: 700">{{
                  config.name
                }}</label>
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center">
                <span>{{ config.department }}</span>
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center">
                <span>{{ config.categoryName }}</span>
              </div>
            </td>

            <td style="text-align: center">
              <div
                class="btn-group dropleft"
                [hidden]="editZone && i === selectedRowIndex"
              >
                <span matTooltip="Add Pricing" matTooltipPosition="above">
                  <button
                    type="button"
                    class="action-drop"
                    (click)="sendData(config)"
                    routerLink="/admin/home/pricing/add-pricing"
                  >
                    <i
                      ><img
                        width="20"
                        src="../../../assets/Pricingscreen/setting.svg"
                    /></i>
                  </button>
                </span>
              </div>
            </td>
          </tr>

          <tr *ngIf="!isLoading && noData">
            <td colspan="8" style="text-align: center">
              <h5>Sorry there is no data</h5>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        *ngIf="isLoading"
        class="loader-overlay"
        class="d-flex justify-content-center align-items-center"
        style="height: 56vh; width: 100%"
      >
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </section>
</div>

<!--Boostrap modal for filter data-->
<div
  class="modal fade"
  id="filterData"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Filters</h5>
      </div>
      <div class="modal-body p-0">
        <div class="filter d-flex">
          <div class="filter-labels">
            <h6 class="ps-4">Lists</h6>
            <div class="filter-labels-wrapper">
              <ul class="list-unstyled">
                <li
                  (click)="selectedFilterCategory('Store')"
                  [ngClass]="{ active: filterName === 'Store' }"
                >
                  Store Group
                  <br />
                  <p *ngIf="storeGroupIDs.length > 0">
                    {{ storeGroupIDs.length }} selected
                  </p>
                </li>
                <li
                  (click)="selectedFilterCategory('Department')"
                  [ngClass]="{ active: filterName === 'Department' }"
                >
                  Department
                  <br />
                  <p *ngIf="filterDepartmentIDs.length > 0">
                    {{ filterDepartmentIDs.length }} selected
                  </p>
                </li>
                <li
                  (click)="selectedFilterCategory('Category')"
                  [ngClass]="{ active: filterName === 'Category' }"
                >
                  Category
                  <br />
                  <p *ngIf="filterCategoriesIDs.length > 0">
                    {{ filterCategoriesIDs.length }} selected
                  </p>
                </li>
                <li
                  (click)="selectedFilterCategory('Condition')"
                  [ngClass]="{ active: filterName === 'Condition' }"
                >
                  Condition
                  <br />
                  <p *ngIf="conditionIDs.length > 0">
                    {{ conditionIDs.length }} selected
                  </p>
                </li>
                <li
                  (click)="selectedFilterCategory('Quality')"
                  [ngClass]="{ active: filterName === 'Quality' }"
                >
                  Quality
                  <br />
                  <p *ngIf="QualityConfigIDs.length > 0">
                    {{ QualityConfigIDs.length }} selected
                  </p>
                </li>
                <li
                  (click)="selectedFilterCategory('Config')"
                  [ngClass]="{ active: filterName === 'Config' }"
                >
                  Price Type
                  <br />
                  <p *ngIf="filterConfigIDs.length > 0">
                    {{ filterConfigIDs.length }} selected
                  </p>
                </li>
                <!--<li (click)="selectedFilterCategory('size')">Size </li>-->
              </ul>
            </div>
          </div>
          <div class="filter-data">
            <h6 class="ps-2">Selected by: {{ filterName }}</h6>
            <div class="filter-data-wrapper">
              <div class="row" *ngIf="filterName == 'Department'">
                <div
                  class="col-lg-3 col-sm-6"
                  *ngFor="
                    let data of DeptpriceconfigarrayforFilters;
                    let idx = index
                  "
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.isSelected == true }"
                    (click)="collectFilterParameters(data.departmentId)"
                  >
                    <i><img class="filtericon" [src]="data.imageIcon" /></i>
                    <span
                      class="mt-2 text-center"
                      style="font-size: 13px; color: black"
                      >{{ data.department }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="filterName == 'Category'">
                <div
                  class="col-lg-3 col-sm-6"
                  *ngFor="
                    let data of DeptpriceconfigarrayforFilters;
                    let idx = index
                  "
                  (click)="collectFilterParameters(data.categoryId)"
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.cIsSelected == true }"
                  >
                    <i><img class="filtericon" [src]="data.cImage" /></i>
                    <span
                      class="mt-2 text-center"
                      style="font-size: 13px; color: black"
                    >
                      {{ data.categoryName }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="filterName == 'Config'">
                <div
                  class="col-lg-3 col-sm-6"
                  *ngFor="
                    let data of DeptpriceconfigarrayforFilters;
                    let idx = index
                  "
                  (click)="collectFilterParameters(data.pricingTypeId)"
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.configSelected == true }"
                  >
                    <!--<i><img class="filtericon" [src]="data.cImage" /></i>-->
                    <span
                      class="mt-2 text-center"
                      style="font-size: 13px; color: black"
                    >
                      {{ data.description }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="filterName == 'Quality'">
                <div
                  class="col-lg-3 col-sm-6"
                  *ngFor="
                    let data of DeptpriceconfigarrayforFilters;
                    let idx = index
                  "
                  (click)="collectFilterParameters(data.qualityId)"
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.qualitySelected == true }"
                  >
                    <!--<i><img class="filtericon" [src]="data.cImage" /></i>-->
                    <span
                      class="mt-2 text-center"
                      style="font-size: 13px; color: black"
                    >
                      {{ data.qualityName }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="filterName == 'Store'">
                <div
                  class="col-lg-3 col-sm-6"
                  *ngFor="
                    let data of DeptpriceconfigarrayforFilters;
                    let idx = index
                  "
                  (click)="collectFilterParameters(data.storeGroupId)"
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.storeGroupIdSelected == true }"
                  >
                    <!--<i><img class="filtericon" [src]="data.cImage" /></i>-->
                    <span
                      class="mt-2 text-center"
                      style="font-size: 13px; color: black"
                    >
                      {{ data.name }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="filterName == 'Condition'">
                <div
                  class="col-lg-3 col-sm-6"
                  *ngFor="
                    let data of DeptpriceconfigarrayforFilters;
                    let idx = index
                  "
                  (click)="collectFilterParameters(data.conditionId)"
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.conditionIdSelected == true }"
                  >
                    <!--<i><img class="filtericon" [src]="data.cImage" /></i>-->
                    <span
                      class="mt-2 text-center"
                      style="font-size: 13px; color: black"
                    >
                      {{ data.conditionName }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <div class="footer-wrapper">
          <button
            class="btn modal-btn me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            style="background-color: #ffffff; color: rgb(23, 95, 145)"
            (click)="openFilterModal('Close')"
          >
            Cancel
          </button>
          <button
            class="btn modal-btn me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            style="background-color: rgb(23, 95, 145); color: white"
            (click)="getFilterData()"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Boostrap modal for add price config-->
<div
  class="modal fade"
  id="addPriceConfigModal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Add New Price Config</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="d-flex align-items-center mb-2">
          <h6 class="head">Select Store Group</h6>
          &nbsp;
          <span class="d-block" style="color: #929292; font-size: 12px"
            >(Select any one)</span
          >
        </div>
        <div
          class="row"
          style="
            overflow: auto;
            height: 335px;
            scrollbar-width: none;
            height: 120px;
          "
        >
          <div
            class="col-sm-2"
            *ngFor="let stroreGrp of storeGroups; let i = index"
          >
            <div
              class="col-wrapper"
              [class.active]="stroreGrp.id === selectedStoregrp"
              (click)="toggleStoreGroups(stroreGrp.id)"
            >
              <i class="fa-solid fa-store"></i>
              <span class="d-block">{{ stroreGrp.name }}</span>
            </div>
          </div>
        </div>
        <div class="secondary-header d-flex justify-content-between">
          <h6 class="head mb-2">Select Department</h6>
          <div
            class="d-flex form-switch"
            style="justify-content: space-between; width: 160px"
          >
            <label class="form-check-label" for="flexSwitchCheckChecked"
              >Select All</label
            >
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckChecked"
              checked
              (click)="toggleSelect($event)"
            />
          </div>
        </div>
        <div
          class="row mt-2"
          style="
            overflow: auto;
            height: 335px;
            scrollbar-width: none;
            height: 245px;
          "
        >
          <div class="col-sm-2" *ngFor="let dept of departmentslist">
            <div
              class="col-wrapper getdept"
              [class.active]="dept.active"
              (click)="getSelectedDepartment(dept.departmentId)"
            >
              <img [src]="dept.imageIcon" />

              <span class="d-block"> {{ dept.departmentDescr }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn modal-btn me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            style="background-color: #ffffff; color: rgb(23, 95, 145)"
          >
            Cancel
          </button>
          <button
            class="btn modal-btn ms-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            style="background-color: rgb(23, 95, 145)"
            routerLink="/admin/home/pricing/add-pricing"
            (click)="dataForPricingConfig(selectedStoregrp)"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Boostrap modal for add price config-->
<div
  class="modal fade"
  id="resetPricing"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Reset Price Config</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="departmentIDs = []; resetStoreID = 0"
        ></button>
      </div>
      <div class="modal-body">
        <div class="mb-3 enter">
          <label for="itemQty" class="form-label"
            >Select Store Group<span style="color: red; font-size: 14px"
              >*</span
            ></label
          >
          <p>:</p>
          <select
            class="form-select"
            aria-label="Default select example"
            [(ngModel)]="resetStoreID"
            (change)="checkID()"
          >
            <option value="0" hidden>Select Store Group</option>
            <option
              *ngFor="let store of storeReset"
              [value]="store.storeGroupId"
            >
              {{ store.name }}
            </option>
          </select>
        </div>
        <div class="mb-3 enter">
          <label for="">Select Deparment</label>
          <p>:</p>
          <div class="custom-select-wrapper" #customSelect>
            <div class="custom-select-box" (click)="toggleCustomSelect()">
              <input
                style="width: 100%"
                type="text"
                [value]="getSelectedDepartmentNames()"
                placeholder="Select Department"
                readonly
              />
              <img
                src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e"
              />
            </div>
            <div
              class="custom-select-option-wrapper"
              *ngIf="!isCustomSelect && resetStoreID > 0"
              style="z-index: 50"
            >
              <div
                *ngFor="let dept of departmentReset; let i = index"
                class="d-flex align-items-center mb-1"
              >
                <!-- Checkbox for departments (inside *ngFor) -->
                <input
                  class="form-check-input mt-0 me-2"
                  type="checkbox"
                  [value]="dept.departmentId"
                  [id]="'flexCheckDefault' + i"
                  (change)="onDepartmentToggle(dept.departmentId, $event)"
                  [checked]="departmentIDs.includes(dept.departmentId)"
                />
                <label [for]="'flexCheckDefault' + i">{{
                  dept.department
                }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn modal-btn me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            style="background-color: #ffffff; color: #0070b9"
            (click)="departmentIDs = []; resetStoreID = 0"
          >
            Cancel
          </button>
          <button
            class="btn modal-btn ms-2"
            data-bs-dismiss="modal"
            (click)="resetPriceConfig()"
            [disabled]="!resetStoreID"
            aria-label="Close"
            style="background-color: rgb(23, 95, 145)"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Boostrap modal for set price to department/categories-->
<div
  class="modal fade"
  id="setPriceConfigModal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-head">
          <h5 class="mb-0 text-nowrap">
            {{ storeGroupName }} <span></span> {{ departmentName }}
          </h5>
          <h5 class="mb-0" *ngIf="showCategoryName">
            <span></span>{{ categoryName }}
          </h5>
          <h5 class="mb-0" *ngIf="showSubCategoryName">
            <span></span>{{ subCategoryName }}
          </h5>
        </div>
      </div>
      <div class="modal-body pt-0">
        <div class="tbl-body">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead class="sticky-top" style="background: white">
                <!--GBB by Category-->
                <tr [hidden]="priceConfigTypeID != 1">
                  <th scope="col" style="width: 50%; padding-left: 2rem">
                    Quality
                  </th>
                  <th scope="col" style="width: 50%">Pricelist</th>
                </tr>
                <!--Quality and Conditions by Category-->
                <tr [hidden]="priceConfigTypeID != 4">
                  <th scope="col" style="padding-left: 2rem">Quality</th>
                  <th>Conditions</th>
                  <th scope="col">Pricelist</th>
                </tr>
                <!--PriceLists by Category-->
                <tr [hidden]="priceConfigTypeID != 2">
                  <th scope="col" style="padding-left: 2rem">Levels</th>
                  <th>PriceList</th>
                  <th scope="col">Actions</th>
                </tr>
                <!-- GBB by Department-->
                <tr [hidden]="priceConfigTypeID != 5">
                  <th scope="col" style="width: 50%; padding-left: 2rem">
                    Quality
                  </th>
                  <th scope="col" style="width: 50%">Pricelist</th>
                </tr>
                <!--Quality and Conditions by Department-->
                <tr [hidden]="priceConfigTypeID != 6">
                  <th scope="col" style="padding-left: 2rem">Quality</th>
                  <th>Conditions</th>
                  <th scope="col">Pricelist</th>
                </tr>
                <!--PriceLists by Department-->
                <tr [hidden]="priceConfigTypeID != 3">
                  <th scope="col" style="padding-left: 2rem">Levels</th>
                  <th>PriceList</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <!-- tbody for GBB by Category-->
                <tr
                  [hidden]="priceConfigTypeID != 1"
                  *ngFor="let data of arrayForEditPriceConfig"
                >
                  <td>
                    <span
                      class="bgColor"
                      [style.backgroundColor]="data.qualityColor"
                    >
                      {{ data.qualityDescr }}
                    </span>
                  </td>
                  <td>
                    <div class="enter-price" style="width: 36%">
                      $<input
                        type="text"
                        [(ngModel)]="data.price"
                        (ngModelChange)="onPriceChange(data)"
                        placeholder="Enter Value"
                        appTwoDigitDecimaNumber
                      />
                    </div>
                  </td>
                </tr>
                <!--tbody for Quality and Conditions by Category-->
                <tr
                  [hidden]="priceConfigTypeID != 4"
                  *ngFor="let data of arrayForEditPriceConfig"
                >
                  <td>
                    <span
                      class="bgColor"
                      [style.backgroundColor]="data.qualityColor"
                    >
                      {{ data.qualityDescr }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="condColor"
                      [style.borderColor]="data.conditionColor"
                    >
                      {{ data.conditionDescr }}
                    </span>
                  </td>
                  <td>
                    <div class="enter-price">
                      $<input
                        type="text"
                        [(ngModel)]="data.price"
                        (ngModelChange)="onPriceChange(data)"
                        placeholder="Enter Value"
                        appTwoDigitDecimaNumber
                      />
                    </div>
                  </td>
                </tr>
                <!-- tbody for PriceLists by Category-->
                <tr
                  [hidden]="priceConfigTypeID != 2"
                  *ngFor="let data of arrayForEditPriceConfig; let i = index"
                >
                  <td style="padding-left: 2rem">Level {{ i + 1 }}</td>
                  <td>
                    <div class="enter-price">
                      $<input
                        type="text"
                        [(ngModel)]="data.price"
                        (ngModelChange)="onPriceChange(data)"
                        placeholder="Enter Value"
                        appTwoDigitDecimaNumber
                      />
                    </div>
                  </td>
                  <td>
                    <div>
                      <button
                        type="button"
                        class="action-drop ms-2"
                        (click)="delSinglePrice(i, data)"
                      >
                        <i
                          ><img
                            style="width: 20px"
                            src="../../../assets/Pricingscreen/delete.svg"
                        /></i>
                      </button>
                    </div>
                  </td>
                </tr>
                <!-- tbody for GBB by Department-->
                <tr
                  [hidden]="priceConfigTypeID != 5"
                  *ngFor="let data of arrayForEditPriceConfig"
                >
                  <td>
                    <span
                      class="bgColor"
                      [style.backgroundColor]="data.qualityColor"
                    >
                      {{ data.qualityDescr }}
                    </span>
                  </td>
                  <td>
                    <div class="enter-price" style="width: 36%">
                      $<input
                        type="text"
                        [(ngModel)]="data.price"
                        (ngModelChange)="onPriceChange(data)"
                        placeholder="Enter Value"
                        appTwoDigitDecimaNumber
                      />
                    </div>
                  </td>
                </tr>
                <!--tbody for Quality and Conditions by Department-->
                <tr
                  [hidden]="priceConfigTypeID != 6"
                  *ngFor="let data of arrayForEditPriceConfig"
                >
                  <td>
                    <span
                      class="bgColor"
                      [style.backgroundColor]="data.qualityColor"
                    >
                      {{ data.qualityDescr }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="condColor"
                      [style.borderColor]="data.conditionColor"
                    >
                      {{ data.conditionDescr }}
                    </span>
                  </td>
                  <td>
                    <div class="enter-price">
                      $<input
                        type="text"
                        [(ngModel)]="data.price"
                        (ngModelChange)="onPriceChange(data)"
                        placeholder="Enter Value"
                        appTwoDigitDecimaNumber
                      />
                    </div>
                  </td>
                </tr>
                <!-- tbody for PriceLists by Department-->
                <tr
                  [hidden]="priceConfigTypeID != 3"
                  *ngFor="let data of arrayForEditPriceConfig; let i = index"
                >
                  <td style="padding-left: 2rem">Level {{ i + 1 }}</td>
                  <td>
                    <div class="enter-price">
                      $
                      <input
                        type="text"
                        [(ngModel)]="data.price"
                        (ngModelChange)="onPriceChange(data)"
                        placeholder="Enter Value"
                        appTwoDigitDecimaNumber
                      />
                    </div>
                  </td>
                  <td>
                    <div>
                      <button
                        type="button"
                        class="action-drop ms-2"
                        (click)="delSinglePrice(i, data)"
                      >
                        <i
                          ><img
                            style="width: 20px"
                            src="../../../assets/Pricingscreen/delete.svg"
                        /></i>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button
                      class="btn modal-btn add-btn ms-2 add-level-btn"
                      [hidden]="
                        priceConfigTypeID != 3 && priceConfigTypeID != 2
                      "
                      (click)="addLevel()"
                    >
                      Add Level
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <!--<button class="btn" style="color: #A6E301; font-weight: 600; padding-left: 2rem;"
                    [hidden]="priceConfigTypeID != 2" (click)="addLevelForPriceConfig()"> Add Level </button>-->
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <button
          class="btn modal-btn me-2"
          data-bs-dismiss="modal"
          aria-label="Close"
          style="background-color: #ffffff; color: #0070b9"
          (click)="resetdata()"
        >
          Cancel
        </button>
        <button
          class="btn modal-btn ms-2"
          data-bs-dismiss="modal"
          aria-label="Close"
          style="background-color: rgb(23, 95, 145)"
          (click)="savedata()"
        >
          Save Price
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Bootstrap modal for Confirm Popup for Delete -->
<div
  class="modal fade"
  id="deleteDataModal"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" *ngIf="!checkDel">
        <h5>Delete Pricing</h5>
      </div>
      <div class="modal-header" *ngIf="checkDel">
        <h5>No Record Selected !</h5>
      </div>
      <div class="modal-body" *ngIf="!checkDel">
        <div class="modal-body-wraapper">
          <p class="fw-bold mb-3">
            <i class="fa-solid fa-exclamation-triangle text-warning me-2"></i>
            You are about to delete the following pricing record(s):
          </p>
          <div class="table-responsive" style="height: 40vh;">
            <table class="table table-sm table-borderless">
              <thead class="table-light sticky-top">
                <tr>
                  <th>Store Group</th>
                  <th>Department</th>
                  <th>Category</th>
                  <th>Price Type</th>
                  <th class="text-end">Cost</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let pricing of getSelectedPricingForDelete()">
                  <td><small>{{ pricing.name }}</small></td>
                  <td><small>{{ pricing.department }}</small></td>
                  <td><small>{{ pricing.categoryName }}</small></td>
                  <td><small>{{ pricing.description }}</small></td>
                  <td class="text-end"><small>{{ pricing.price | currency }}</small></td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="fw-bold mt-3 text-danger">
            <i class="fa-solid fa-circle-exclamation me-2"></i>
            Once deleted, all the saved data will get deleted and cannot be recovered.
          </p>
        </div>
      </div>
      <div class="modal-body" *ngIf="checkDel">
        <div class="modal-body-wraapper">
          <p>Please select one or more records to delete.</p>
        </div>
      </div>

      <div class="custom-modal-footer modal-footer">
        <button
          style="color: rgb(23, 95, 145)"
          class="btn modal-btn me-2"
          data-dismiss="modal"
          aria-label="Close"
          #modalConfirmCloseButton
        >
          Close
        </button>
        <button
          button
          class="btn btn-danger"
          data-dismiss="modal"
          aria-label="Close"
          *ngIf="!checkDel"
          (click)="deletePricing()"
        >
          <i class="fa-solid fa-trash me-2"></i>
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Hidden button to trigger Import Data modal -->
<button
  #importModal
  data-bs-target="#importDataModal"
  data-bs-toggle="modal"
  class="d-none"
></button>

<!--Bootstrap modal for Import Data-->
<div
  class="modal fade"
  id="importDataModal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  aria-hidden="true"
  aria-labelledby="importDataModalLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Import Pricing Data</h5>
        <button
          #importModalClose
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="cancelImport()"
        ></button>
      </div>
      <div class="modal-body">
        <div class="alert alert-info">
          <strong>Import Instructions:</strong>
          <ul class="mb-0 mt-2">
            <li>File must be in Excel format (.xlsx or .xls)</li>
            <li>
              Required columns: Store Group, Department, Category, Sub-Category
              (if applicable), Price Type, Quality, Condition (if applicable),
              Price
            </li>
            <li>Each department can only have one pricing type</li>
            <li>Download the template for the correct format</li>
          </ul>
        </div>

        <div class="mb-3">
          <button class="btn btn-outline-primary" (click)="downloadTemplate()">
            <i class="fa fa-download"></i> Download Import Template
          </button>
        </div>

        <div *ngIf="importErrors.length > 0" class="alert alert-danger">
          <strong>Import Errors:</strong>
          <ul class="mb-0 mt-2">
            <li *ngFor="let error of importErrors">{{ error }}</li>
          </ul>
        </div>

        <div *ngIf="importPreview.length > 0 && !isImportLoading">
          <h6>Preview (First 10 rows):</h6>
          <div
            class="table-responsive"
            style="max-height: 300px; overflow-y: auto"
          >
            <table class="table table-sm table-bordered">
              <thead class="sticky-top bg-white">
                <tr>
                  <th>Store Group</th>
                  <th>Department</th>
                  <th>Category</th>
                  <th>Sub-Category</th>
                  <th>Price Type</th>
                  <th>Quality</th>
                  <th>Condition</th>
                  <th>Price</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of importPreview">
                  <td>{{ row.storeGroup }}</td>
                  <td>{{ row.department }}</td>
                  <td>{{ row.category }}</td>
                  <td>{{ row.subCategory }}</td>
                  <td>{{ row.priceType }}</td>
                  <td>{{ row.quality }}</td>
                  <td>{{ row.condition }}</td>
                  <td>{{ row.price | currency }}</td>
                  <td>
                    <span [class]="row.valid ? 'text-success' : 'text-danger'">
                      {{ row.valid ? "✓ Valid" : "✗ Invalid" }}
                    </span>
                    <span>
                      <ng-container *ngIf="!row.valid">
                        <ul class="mb-0">
                          <li
                            *ngFor="let err of row.errors"
                            class="text-danger"
                          >
                            {{ err }}
                          </li>
                        </ul>
                      </ng-container>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="mt-2">
            <strong>Total Rows:</strong> {{ importData.length }} |
            <strong>Valid:</strong> {{ validImportRows }} |
            <strong>Invalid:</strong> {{ importData.length - validImportRows }}
          </p>
        </div>
        <div>
          <div *ngIf="isImportLoading" class="mt-2">
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading file...
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <button
          class="btn modal-btn me-2"
          data-bs-dismiss="modal"
          aria-label="Close"
          style="background-color: #ffffff; color: rgb(23, 95, 145)"
          (click)="cancelImport()"
        >
          Cancel
        </button>
        <button
          class="btn modal-btn ms-2"
          style="background-color: rgb(23, 95, 145)"
          (click)="processImport()"
          [disabled]="importData.length - validImportRows > 0 || isImporting"
        >
          {{ isImporting ? "Importing..." : "Import Data" }}
        </button>
      </div>
    </div>
  </div>
</div>
